import { PageOutgoingInvoices } from "@components/modules/invoices/outgoing/listing/PageOutgoingInvoices";
import { NavigationFinance } from "@components/widgets/AppSubNav";
import { DemoModule, Modules } from "@components/widgets/DemoModule";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout title={t`Outgoing invoices`} navigation={<NavigationFinance />}>
    <DemoModule module={Modules.InvoicesOutgoingInvoices}>
      <PageOutgoingInvoices />
    </DemoModule>
  </MainLayout>
);

export const Route = createFileRoute("/invoices/outgoing-invoices/")({
  component: Page,
});
